import { Vue } from "vue-class-component";
export default class ChartMixin extends Vue {
  mounted() {
    window.addEventListener("resize", this.draw);
  }
  beforeUnmount() {
    window.removeEventListener("resize", this.draw);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  draw() {}
}
